import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../app/hooks";

interface SupportLinkProps {
	id: string;
	className?: string;
	article?: string;
	children: React.ReactNode;
}

export const SupportLink = forwardRef<HTMLAnchorElement, SupportLinkProps>(
	(props: SupportLinkProps, ref) => {
		const { aspUrl } = useAppSelector((state) => state.site);

		return (
			<Link
				to={`${aspUrl}/Support${props.article ? "/" + props.article : ""}?spa`}
				target="_blank"
				rel="noopener noreferrer"
				ref={ref}
				id={props.id}
				className={props.className}>
				{props.children}
			</Link>
		);
	}
);

export default SupportLink;
